(function($) {
    $(document).ready(function() {
      $('body').on('click', '#member-search-result tr', function (event) {
          event.stopPropagation()
          if(event.target.nodeName === 'A') {
              return
          }

          var link = $(this).find('a');

          if (link.length) {
              link[0].click()
          }
      })
    })
})(window.jQuery);
